import Sidebar from '../components/Sidebar';
import ProductThumbnail from '../components/ProductThumbnail';

export default class Search {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.productThumbnailsElements = this.el.querySelectorAll('[data-product-thumbnail]');
    this.productThumbnails = [];
    const thumbnailSettings = {
      showSecondaryMediaOnHover: this.settings.show_secondary_media,
    };

    this.sidebar = new Sidebar(this.el);
    this.productThumbnailsElements.forEach(productThumbnail => {
      this.productThumbnails.push(new ProductThumbnail(productThumbnail, thumbnailSettings));
    });
  }

  onSectionUnload() {
    this.sidebar.unload();
    this.productThumbnails.forEach(productThumbnail => productThumbnail.unload());
  }
}
